export const redirectTo = url => {
  window.location.href = url;
};
export const getCurrentPath = () => window.location.pathname;